import { Grid, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/WarningRounded";
import React, { FC } from "react";
import useStyles from "./styles";

const DPErrorMessage: FC = () => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      className={classes.root}
      justify="center"
    >
      <Grid item>
        <WarningIcon fontSize="large" className={classes.icon} />
        <Typography variant="h2" align="center">
          We’re sorry there seems to be a problem loading this.
        </Typography>
        <Typography variant="body1" align="center">
          Please refresh the page or contact DailyPay.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default DPErrorMessage;
